import { render, staticRenderFns } from "./CargaCatedraticosView.vue?vue&type=template&id=418dc86b&scoped=true"
import script from "./CargaCatedraticosView.vue?vue&type=script&lang=js"
export * from "./CargaCatedraticosView.vue?vue&type=script&lang=js"
import style0 from "./CargaCatedraticosView.vue?vue&type=style&index=0&id=418dc86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418dc86b",
  null
  
)

export default component.exports